import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = { email: string };

export const useLoginCustomerForgotPassword = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/password-reset-request',
      method: 'POST',
      data: variables,
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
